import { render, staticRenderFns } from "./PdfDocumentCreateShow.vue?vue&type=template&id=606ab7ca&"
import script from "./PdfDocumentCreateShow.vue?vue&type=script&lang=js&"
export * from "./PdfDocumentCreateShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports